// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollHSFEarningList } from "../../components/PayrollHSFEarningList/PayrollHSFEarningList";

export interface IPayrollHSFEarningsListPage {}

export const PayrollHSFEarningsListPage: FC<IPayrollHSFEarningsListPage> = (
  props: IPayrollHSFEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll HSF Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-federal-earning/list" },
      ]}
      mainContents={<PayrollHSFEarningList />}
    />
  );
};
